import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axiosInstance from "../../Fbaseurl";
import {
  isSignInWithEmailLink,
  onAuthStateChanged,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signInWithEmailLink,
} from "firebase/auth";

import {
  setCurrentRole,
  setIsAuthorised,
  setUserName,
} from "../../store/reducers/AppReducer";
import { showToast } from "../../store/reducers/ToastMessageReducer";
import { setSelectedTab } from "../../store/reducers/SuperAdminReducer";
import { setSalesPersonSelectedTab } from "../../store/reducers/SalespersonReducer";

import CircularProgress from "@mui/material/CircularProgress";
import "./index.css";
import loginLogo from "../../../src/assets/loginLogo.svg";
import Logo from "../../../src/assets/Taxraven.svg";
import {
  getStoredIdToken,
  persistIdToken,
  clearStoredIdToken,
} from "../../lib/tokenUtils";
import {
  getRoleBasePath,
  isSuperAdminRole,
  normalizeRoleForRouting,
} from "../../CommonUtils/roles";
import { auth } from "../../lib/firebase";
import {
  getFreshIdToken,
  handleGoogleRedirectResult,
  signInWithGooglePopupSmart,
  signInWithMicrosoftPopupSmart,
  firebaseSignOut,
  runSsoExchangeOnce,
} from "../../lib/firebaseAuth";

const COUNTRIES = [
  { code: "AF", dialCode: "+93",  name: "Afghanistan" },
  { code: "AL", dialCode: "+355", name: "Albania" },
  { code: "DZ", dialCode: "+213", name: "Algeria" },
  { code: "AR", dialCode: "+54",  name: "Argentina" },
  { code: "AU", dialCode: "+61",  name: "Australia" },
  { code: "AT", dialCode: "+43",  name: "Austria" },
  { code: "BD", dialCode: "+880", name: "Bangladesh" },
  { code: "BE", dialCode: "+32",  name: "Belgium" },
  { code: "BR", dialCode: "+55",  name: "Brazil" },
  { code: "CA", dialCode: "+1",   name: "Canada" },
  { code: "CN", dialCode: "+86",  name: "China" },
  { code: "CO", dialCode: "+57",  name: "Colombia" },
  { code: "EG", dialCode: "+20",  name: "Egypt" },
  { code: "FR", dialCode: "+33",  name: "France" },
  { code: "DE", dialCode: "+49",  name: "Germany" },
  { code: "GH", dialCode: "+233", name: "Ghana" },
  { code: "GR", dialCode: "+30",  name: "Greece" },
  { code: "IN", dialCode: "+91",  name: "India" },
  { code: "ID", dialCode: "+62",  name: "Indonesia" },
  { code: "IR", dialCode: "+98",  name: "Iran" },
  { code: "IQ", dialCode: "+964", name: "Iraq" },
  { code: "IE", dialCode: "+353", name: "Ireland" },
  { code: "IL", dialCode: "+972", name: "Israel" },
  { code: "IT", dialCode: "+39",  name: "Italy" },
  { code: "JP", dialCode: "+81",  name: "Japan" },
  { code: "JO", dialCode: "+962", name: "Jordan" },
  { code: "KE", dialCode: "+254", name: "Kenya" },
  { code: "KR", dialCode: "+82",  name: "South Korea" },
  { code: "KW", dialCode: "+965", name: "Kuwait" },
  { code: "LB", dialCode: "+961", name: "Lebanon" },
  { code: "MY", dialCode: "+60",  name: "Malaysia" },
  { code: "MX", dialCode: "+52",  name: "Mexico" },
  { code: "MA", dialCode: "+212", name: "Morocco" },
  { code: "NL", dialCode: "+31",  name: "Netherlands" },
  { code: "NZ", dialCode: "+64",  name: "New Zealand" },
  { code: "NG", dialCode: "+234", name: "Nigeria" },
  { code: "NO", dialCode: "+47",  name: "Norway" },
  { code: "PK", dialCode: "+92",  name: "Pakistan" },
  { code: "PH", dialCode: "+63",  name: "Philippines" },
  { code: "PL", dialCode: "+48",  name: "Poland" },
  { code: "PT", dialCode: "+351", name: "Portugal" },
  { code: "QA", dialCode: "+974", name: "Qatar" },
  { code: "RO", dialCode: "+40",  name: "Romania" },
  { code: "RU", dialCode: "+7",   name: "Russia" },
  { code: "SA", dialCode: "+966", name: "Saudi Arabia" },
  { code: "SG", dialCode: "+65",  name: "Singapore" },
  { code: "ZA", dialCode: "+27",  name: "South Africa" },
  { code: "ES", dialCode: "+34",  name: "Spain" },
  { code: "LK", dialCode: "+94",  name: "Sri Lanka" },
  { code: "SE", dialCode: "+46",  name: "Sweden" },
  { code: "CH", dialCode: "+41",  name: "Switzerland" },
  { code: "TW", dialCode: "+886", name: "Taiwan" },
  { code: "TH", dialCode: "+66",  name: "Thailand" },
  { code: "TR", dialCode: "+90",  name: "Turkey" },
  { code: "UA", dialCode: "+380", name: "Ukraine" },
  { code: "AE", dialCode: "+971", name: "UAE" },
  { code: "GB", dialCode: "+44",  name: "United Kingdom" },
  { code: "US", dialCode: "+1",   name: "United States" },
  { code: "VN", dialCode: "+84",  name: "Vietnam" },
];

const PHONE_RULES = {
  AF: { min: 9,  max: 9  },
  AL: { min: 9,  max: 9  },
  DZ: { min: 9,  max: 9  },
  AR: { min: 10, max: 10 },
  AU: { min: 9,  max: 9  },
  AT: { min: 10, max: 11 },
  BD: { min: 10, max: 10 },
  BE: { min: 9,  max: 9  },
  BR: { min: 10, max: 11 },
  CA: { min: 10, max: 10 },
  CN: { min: 11, max: 11 },
  CO: { min: 10, max: 10 },
  EG: { min: 10, max: 10 },
  FR: { min: 9,  max: 9  },
  DE: { min: 10, max: 11 },
  GH: { min: 9,  max: 9  },
  GR: { min: 10, max: 10 },
  IN: { min: 10, max: 10 },
  ID: { min: 9,  max: 12 },
  IR: { min: 10, max: 10 },
  IQ: { min: 10, max: 10 },
  IE: { min: 9,  max: 9  },
  IL: { min: 9,  max: 9  },
  IT: { min: 9,  max: 10 },
  JP: { min: 10, max: 11 },
  JO: { min: 9,  max: 9  },
  KE: { min: 9,  max: 9  },
  KR: { min: 9,  max: 10 },
  KW: { min: 8,  max: 8  },
  LB: { min: 7,  max: 8  },
  MY: { min: 9,  max: 10 },
  MX: { min: 10, max: 10 },
  MA: { min: 9,  max: 9  },
  NL: { min: 9,  max: 9  },
  NZ: { min: 8,  max: 9  },
  NG: { min: 10, max: 10 },
  NO: { min: 8,  max: 8  },
  PK: { min: 10, max: 10 },
  PH: { min: 10, max: 10 },
  PL: { min: 9,  max: 9  },
  PT: { min: 9,  max: 9  },
  QA: { min: 8,  max: 8  },
  RO: { min: 9,  max: 9  },
  RU: { min: 10, max: 10 },
  SA: { min: 9,  max: 9  },
  SG: { min: 8,  max: 8  },
  ZA: { min: 9,  max: 9  },
  ES: { min: 9,  max: 9  },
  LK: { min: 9,  max: 9  },
  SE: { min: 9,  max: 9  },
  CH: { min: 9,  max: 9  },
  TW: { min: 9,  max: 9  },
  TH: { min: 9,  max: 9  },
  TR: { min: 10, max: 10 },
  UA: { min: 9,  max: 9  },
  AE: { min: 9,  max: 9  },
  GB: { min: 10, max: 10 },
  US: { min: 10, max: 10 },
  VN: { min: 9,  max: 10 },
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [authUser, setAuthUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const [ssoCookieChecked, setSsoCookieChecked] = useState(false);
  const [emailLinkInProgress, setEmailLinkInProgress] = useState(false);
  const [emailLinkError, setEmailLinkError] = useState("");
  const [redirectAuthError, setRedirectAuthError] = useState("");
  const [isEmailLinkFlow, setIsEmailLinkFlow] = useState(false);
  const [phoneAuthOpen, setPhoneAuthOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    COUNTRIES.find((c) => c.code === "US")
  );
  const [localPhone, setLocalPhone] = useState("");
  const [countrySearch, setCountrySearch] = useState("");
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const countryDropdownRef = useRef(null);
  const [otpCode, setOtpCode] = useState("");
  const [phoneAuthStep, setPhoneAuthStep] = useState("idle");
  const [phoneAuthError, setPhoneAuthError] = useState("");
  const [phoneAuthLoading, setPhoneAuthLoading] = useState(false);
  const [continueSubmitting, setContinueSubmitting] = useState(false);
  const recaptchaRef = useRef(null);
  const confirmationRef = useRef(null);
  const [emailOtpOpen, setEmailOtpOpen] = useState(false);
  const [emailOtpRequestedEmail, setEmailOtpRequestedEmail] = useState("");
  const [emailOtpCode, setEmailOtpCode] = useState("");
  const [emailOtpLoading, setEmailOtpLoading] = useState(false);
  const [emailOtpError, setEmailOtpError] = useState("");
  const emailOtpRefs = useRef([]);
  const phoneDigits = localPhone.replace(/\D/g, "");
  const fullPhoneNumber = `${selectedCountry.dialCode}${phoneDigits}`;
  const phoneRule = PHONE_RULES[selectedCountry.code] ?? { min: 7, max: 15 };
  const isPhoneValid = phoneDigits.length >= phoneRule.min && phoneDigits.length <= phoneRule.max;
  const filteredCountries = COUNTRIES.filter(
    (c) =>
      c.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
      c.dialCode.includes(countrySearch)
  );

  const reportAuthError = useCallback(
    (message, code) => {
      const finalMessage = getFirebaseAuthError(code || "", message || "Something went wrong. Please try again.");
      setRedirectAuthError(finalMessage);
      dispatch(showToast({ type: "error", message: finalMessage }));
    },
    [dispatch]
  );

  function getApiErrorMessage(message, status) {
    const msg = (message || "").toLowerCase();
    if (status === 429 || msg.includes("too many attempt") || msg.includes("too many request")) {
      return "Too many attempts, please try again after 24-48 hours.";
    }
    if (status === 500 || msg.includes("internal server error")) {
      return "Your onboarding session is currently active in another browser or device. Please complete it there, or close that session and try again.";
    }
    return message || "Something went wrong. Please try again.";
  }

  function getFirebaseAuthError(code, message) {
    const normalizedCode =
      code ||
      (typeof message === "string" && message.includes("auth/cancelled-popup-request")
        ? "auth/cancelled-popup-request"
        : typeof message === "string" && message.includes("auth/popup-blocked")
        ? "auth/popup-blocked"
        : typeof message === "string" && message.includes("auth/popup-closed-by-user")
        ? "auth/popup-closed-by-user"
        : "");
    const lowerMessage = (message || "").toLowerCase();

    if (
      normalizedCode === "auth/error-code:-47" ||
      normalizedCode === "-47" ||
      lowerMessage.includes("auth/error-code:-47")
    ) {
      return "Access not authorized. Please contact support.";
    }
    if (normalizedCode === "auth/invalid-phone-number" || lowerMessage.includes("invalid-phone-number")) {
      return "Invalid phone number. Please enter a valid number.";
    }
    if (
      normalizedCode === "auth/popup-closed-by-user" ||
      normalizedCode === "auth/cancelled-popup-request" ||
      normalizedCode === "auth/popup-blocked"
    ) {
      return "Sign-in popup was closed. Please try again.";
    }
    if (normalizedCode === "auth/account-exists-with-different-credential") {
      return "Use the appropriate login method for the specified email ID.";
    }
    if (normalizedCode === "auth/network-request-failed" || lowerMessage.includes("network-request-failed")) {
      return "Network error. Please check your connection and try again.";
    }
    if (normalizedCode === "auth/user-disabled") {
      return "This account has been disabled. Please contact support.";
    }
    if (normalizedCode === "auth/invalid-verification-code") {
      return "Invalid OTP. Please check the code and try again.";
    }
    if (normalizedCode === "auth/code-expired") {
      return "OTP has expired. Please request a new code.";
    }
    if (normalizedCode === "auth/too-many-requests" || lowerMessage.includes("too-many-requests")) {
      return "Too many attempts, please try again after 24-48 hours.";
    }
    if (normalizedCode === "auth/captcha-check-failed" || lowerMessage.includes("captcha-check-failed")) {
      return "reCAPTCHA verification failed. Please try again.";
    }
    if (normalizedCode === "auth/internal-error" || lowerMessage.includes("internal-error")) {
      return "An error occurred. Please try again.";
    }
    if (normalizedCode === "auth/missing-phone-number" || lowerMessage.includes("missing-phone-number")) {
      return "Please enter a phone number.";
    }
    if (normalizedCode === "auth/quota-exceeded" || lowerMessage.includes("quota-exceeded")) {
      return "SMS quota exceeded. Please try again later.";
    }
    if (normalizedCode === "auth/operation-not-allowed" || lowerMessage.includes("operation-not-allowed")) {
      return "Phone sign-in is not enabled. Please contact support.";
    }
    if (normalizedCode === "auth/argument-error" || lowerMessage.includes("argument-error")) {
      return "Invalid request. Please refresh the page and try again.";
    }
    return message || code || "Something went wrong. Please try again.";
  }

  const getSsoProviderForEmail = async (email) => {
    const domain = (email.split("@")[1] || "").toLowerCase().trim();
    if (!domain) return "unknown";

    if (domain === "gmail.com" || domain.endsWith(".googlemail.com")) {
      return "google";
    }

    if (["outlook.com", "hotmail.com", "live.com", "msn.com"].includes(domain)) {
      return "microsoft";
    }

    try {
      const res = await fetch(
        `https://dns.google/resolve?name=${encodeURIComponent(domain)}&type=MX`
      );
      if (!res.ok) return "unknown";
      const data = await res.json().catch(() => null);
      const records = Array.isArray(data?.Answer)
        ? data.Answer
            .map((answer) => String(answer?.data || "").toLowerCase())
            .join(" ")
        : "";

      if (!records) return "unknown";
      if (records.includes("google.com")) return "google";
      if (
        records.includes("outlook.com") ||
        records.includes("protection.outlook.com") ||
        records.includes("microsoft.com") ||
        records.includes("office365.com") ||
        records.includes("onmicrosoft.com")
      ) {
        return "microsoft";
      }
    } catch {
      // ignore DNS lookup failures
    }

    return "unknown";
  };
  const hasAuthRedirectParams =
    typeof window !== "undefined" &&
    (() => {
      const params = new URLSearchParams(window.location.search);
      return (
        params.has("oobCode") ||
        params.get("mode") === "signIn" ||
        params.has("apiKey") ||
        params.has("login_hint") ||
        params.has("redirect_url") ||
        params.has("email")
      );
    })();

  // The hint only pre-fills the email field. It used to also drive an automatic
  // Google redirect, which raced the SSO handoff below and could loop forever.
  const [loginHint, setLoginHint] = useState(() => {
    if (typeof window === "undefined") return "";
    try {
      const params = new URLSearchParams(window.location.search);
      return (
        params.get("login_hint") || localStorage.getItem("lastLoginHint") || ""
      );
    } catch {
      return "";
    }
  });

  useEffect(() => {
    handleGoogleRedirectResult().catch((err) => {
      const message =
        err?.message || err?.code || "Google sign-in failed. Please try again.";
      reportAuthError(message, err?.code);
    });
  }, []);

  // Email-link completion flow
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isEmailLink = isSignInWithEmailLink(auth, window.location.href);
    const redirectUrl = params.get("redirect_url") || "";

    setIsEmailLinkFlow(isEmailLink);

    if (!isEmailLink) return;

    if (redirectUrl) {
      sessionStorage.setItem("pending_redirect_url", redirectUrl);
    }

    const email =
      params.get("email") || window.localStorage.getItem("emailForSignIn");
    if (!email) {
      setEmailLinkError("Missing email for email-link sign-in.");
      return;
    }

    setEmailLinkInProgress(true);
    signInWithEmailLink(auth, email, window.location.href)
      .then(() => {
        window.localStorage.removeItem("emailForSignIn");
        window.history.replaceState({}, document.title, window.location.pathname);
      })
      .catch((err) => {
        setEmailLinkError(err?.message || "Email-link sign-in failed.");
      })
      .finally(() => {
        setEmailLinkInProgress(false);
      });
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        try {
          sessionStorage.removeItem("authExpired");
        } catch {
          // ignore storage errors
        }
        setAuthUser(user);
        setAuthReady(true);
        return;
      }
      // Firebase is the only identity. A token left in localStorage with no
      // Firebase user behind it can't be refreshed, possibly belongs to someone
      // else, and used to be adopted as a session ahead of the SSO handoff.
      clearStoredIdToken();
      setAuthUser(null);
      setAuthReady(true);
    });
    return () => unsubscribe();
  }, []);


  useEffect(() => {
    if (!authReady) return;
    if (authUser || isEmailLinkFlow) {
      setSsoCookieChecked(true);
      return;
    }
    runSsoExchangeOnce().finally(() => {
      // The hint has already been copied into the email field; drop it from
      // the URL so a failed handoff lands on the form, not a loader.
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.has("login_hint")) {
          url.searchParams.delete("login_hint");
          window.history.replaceState({}, document.title, url.pathname + url.search);
        }
      } catch {
        // ignore URL/history errors
      }
      setSsoCookieChecked(true);
    });
  }, [authReady, authUser, isEmailLinkFlow]);

  useEffect(() => {
    if (!phoneAuthOpen) return;
    setupRecaptcha().catch((err) => {
      console.error("Failed to initialize reCAPTCHA on open.", err);
    });
  }, [phoneAuthOpen]);

  useEffect(() => {
    if (!emailOtpOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const focusTimer = setTimeout(() => {
      emailOtpRefs.current[0]?.focus();
    }, 0);
    return () => {
      clearTimeout(focusTimer);
      document.body.style.overflow = prevOverflow;
    };
  }, [emailOtpOpen]);

  useEffect(() => {
    const handler = (e) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
        setCountryDropdownOpen(false);
        setCountrySearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (!localPhone.startsWith("+")) return;
    const raw = localPhone.trim();
    const match = COUNTRIES
      .filter((c) => raw.startsWith(c.dialCode))
      .sort((a, b) => b.dialCode.length - a.dialCode.length)[0];
    if (!match) return;
    if (match.dialCode === "+1") {
      const us = COUNTRIES.find((c) => c.code === "US");
      if (us) setSelectedCountry(us);
    } else {
      setSelectedCountry(match);
    }
    setLocalPhone(raw.slice(match.dialCode.length).replace(/\D/g, ""));
  }, [localPhone]);

  const handleAuthFailure = useCallback(
    (message, code) => {
      reportAuthError(message, code);
      setAuthUser(null);
      setAuthReady(true);
    },
    [reportAuthError]
  );

  const handleAccessDenied = useCallback(async () => {
    try {
      sessionStorage.setItem("authExpired", "1");
    } catch {
      // ignore storage errors
    }
    clearStoredIdToken();
    await firebaseSignOut().catch(() => {});
    setAuthUser(null);
    setAuthReady(true);
  }, []);

  const getFriendlyAuthError = useCallback(
    (err, fallback) => getFirebaseAuthError(err?.code || "", err?.message || fallback || ""),
    []
  );

  const setAuthFromUser = useCallback((user) => {
    if (!user) return;
    setAuthUser(user);
    setAuthReady(true);
  }, []);

  const handleSocialLogin = useCallback(async (provider) => {
    setRedirectAuthError("");
    try {
      const result =
        provider === "google"
          ? await signInWithGooglePopupSmart(undefined, { prompt: "select_account" })
          : await signInWithMicrosoftPopupSmart(undefined, { prompt: "select_account" });

      const popupEmail = result?.user?.email || auth.currentUser?.email || "";
      if (!popupEmail) {
        reportAuthError(
          "We couldn't get an email from your Google/Microsoft account. Please choose an account with an email address or continue using your work email."
        );
        await firebaseSignOut().catch(() => {});
        return;
      }
      const allowed = await checkLrpAccess(popupEmail);
      if (!allowed) {
        await handleAccessDenied();
        return;
      }
      if (result?.user) {
        setAuthFromUser(result.user);
      }
    } catch (err) {
      const message = getFriendlyAuthError(
        err,
        "Login failed. Please try again."
      );
      handleAuthFailure(message);
    }
  }, [setAuthFromUser, handleAuthFailure, getFriendlyAuthError]);

  const handleLogin = async () => {
    const email =
      (loginHint || "").trim() ||
      (authUser?.email || "").trim() ||
      window.localStorage.getItem("lastLoginHint") ||
      "";
    if (!email) return;
    if (continueSubmitting) return;

    setContinueSubmitting(true);
    setRedirectAuthError("");
    window.localStorage.setItem("emailForSignIn", email);

    try {
      const allowed = await checkLrpAccess(email);
      if (!allowed) return;
      const provider = await getSsoProviderForEmail(email);
      if (provider === "google") {
        await signInWithGooglePopupSmart(email);
        return;
      }
      if (provider === "microsoft") {
        await signInWithMicrosoftPopupSmart(email);
        return;
      }
      await sendEmailOtp(email);
    } catch (err) {
      reportAuthError(err?.message || "Unable to verify user. Please try again.", err?.code);
    } finally {
      setContinueSubmitting(false);
    }
  };

  const checkLrpAccess = async (email) => {
    try {
      const encoded = encodeURIComponent(email.trim());
      const res = await fetch(
        `https://api-lrp-dashboard-uat.azurewebsites.net/api/v1/users/CheckLRPUserAccess?email=${encoded}`,
        { method: "GET", headers: { accept: "text/plain" } }
      );
      if (!res.ok) {
        reportAuthError("Access not found for this email.");
        return false;
      }
      const text = await res.text().catch(() => "");
      let json = null;
      try {
        json = text ? JSON.parse(text) : null;
      } catch {
        json = null;
      }
      const hasError =
        (typeof json?.error === "string" && json.error.trim().length > 0) ||
        text.toLowerCase().includes("does not exist");
      if (hasError) {
        reportAuthError("Access not found for this email.");
        return false;
      }
      return true;
    } catch (err) {
      console.error("LRP access check failed:", err);
      reportAuthError("Unable to verify access. Please try again.");
      return false;
    }
  };

  const setupRecaptcha = async () => {
    const container = document.getElementById("recaptcha-container");
    if (!container) {
      throw new Error("reCAPTCHA container not found.");
    }

    if (recaptchaRef.current) {
      return recaptchaRef.current;
    }

    recaptchaRef.current = new RecaptchaVerifier(auth, "recaptcha-container", {
      size: "invisible",
      callback: () => {},
      "expired-callback": () => {},
    });

    await recaptchaRef.current.render();
    window.recaptchaVerifier = recaptchaRef.current;
    return recaptchaRef.current;
  };

  const handleSendOtp = async () => {
    if (!isPhoneValid) {
      setPhoneAuthError("Please enter a valid phone number.");
      return;
    }
    setPhoneAuthError("");
    setPhoneAuthLoading(true);
    try {
      const verifier = await setupRecaptcha();
      const confirmation = await signInWithPhoneNumber(
        auth,
        fullPhoneNumber,
        verifier
      );
      confirmationRef.current = confirmation;
      window.confirmationResult = confirmation;
      setPhoneAuthStep("code-sent");
    } catch (err) {
      setPhoneAuthError(getFirebaseAuthError(err?.code || "", err?.message || "Failed to send OTP. Please try again."));
      try {
        if (recaptchaRef.current) {
          recaptchaRef.current.clear();
        }
      } catch {}
      recaptchaRef.current = null;
    } finally {
      setPhoneAuthLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otpCode.trim()) {
      setPhoneAuthError("Enter the 6-digit OTP.");
      return;
    }
    if (!confirmationRef.current) {
      setPhoneAuthError("OTP session expired. Please request a new code.");
      return;
    }
    setPhoneAuthError("");
    setPhoneAuthLoading(true);
    try {
      await confirmationRef.current.confirm(otpCode.trim());
      setOtpCode("");
      setPhoneAuthStep("idle");
    } catch (err) {
      const code = err?.code || "";
      const message = err?.message || "";
      const isAccessError =
        code === "auth/error-code:-47" ||
        code === "-47" ||
        message.includes("auth/error-code:-47");
      if (isAccessError) {
        reportAuthError("Access not authorized. Please contact support.", code);
      } else {
        reportAuthError(getFirebaseAuthError(code, message || "Invalid OTP. Please try again."), code);
      }
      setPhoneAuthError(getFirebaseAuthError(code, message || "Invalid OTP. Please try again."));
    } finally {
      setPhoneAuthLoading(false);
    }
  };

  // Main authentication effect
  useEffect(() => {
    if (authReady && authUser) {
      handleAuthenticatedUser();
    }
  }, [authReady, authUser]);

  // Get current user info from Graph API
  const handleAuthenticatedUser = async () => {
    try {
      console.log("Handling authenticated user...");

      const email =
        authUser?.email || authUser?.providerData?.[0]?.email || "";
      if (!email) {
        const message = "No email found on authenticated user.";
        console.error(message);
        reportAuthError(message);
        return;
      }

      let accessToken = await getFreshIdToken(false);
      if (!accessToken) {
        accessToken = getStoredIdToken();
      }
      if (!accessToken) {
        throw new Error("Failed to get Firebase token");
      }

      persistIdToken(accessToken);
      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accessToken}`;
      dispatch(setIsAuthorised(true));

      // Store login hint for future SSO
      localStorage.setItem("lastLoginHint", email);

      const allowed = await checkLrpAccess(email);
      if (!allowed) {
        await handleAccessDenied();
        return;
      }

      // Fetch user info using your existing API
      await fetchUserInfo(email);
    } catch (error) {
      console.log("Error handling authenticated user:", error);

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Login failed. Please try again.";
      handleAuthFailure(message);
    }
  };

  const fetchUserInfo = async (email) => {
    try {
      console.log("Fetching user info for:", email);

      const response = await axiosInstance.get(`/users/${email}`);
      if (response.status === 200) {
        let userName = `${response.data.firstName} ${response?.data?.lastName}`;
        localStorage.setItem("userName", userName);
        localStorage.setItem("userId", response.data.userName);
        localStorage.setItem("companyAssigned", response.data.companyId);
        localStorage.setItem("user", JSON.stringify(response.data));
        dispatch(setUserName(userName));
        const pendingRedirect = sessionStorage.getItem("pending_redirect_url");
        if (pendingRedirect) {
          await getCurrentRole({ navigateOnResolve: false });
          sessionStorage.removeItem("pending_redirect_url");
          window.location.href = pendingRedirect;
          return;
        }
        getCurrentRole();
      }
    } catch (error) {
      console.log("Error fetching user info:", error);
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        handleAuthFailure("Your session expired. Please sign in again.");
        return;
      }
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch user info.";
      handleAuthFailure(message);
    }
  };

  const getDefaultRouteForRole = (role) => {
    if (!role) return "";
    const normalizedRole = normalizeRoleForRouting(role);
    if (normalizedRole === "Salesperson") {
      return `${getRoleBasePath(normalizedRole)}/findBusinavTab`;
    }
    switch (normalizedRole) {
      case "Manager":
        return "/manager/dashboard/users";
      case "CompanyAdmin":
        return "/companyadmin/dashboard/users";
      default:
        return "/superadmin/dashboard/companies";
    }
  };

  const getCurrentRole = async ({ navigateOnResolve = true } = {}) => {
    try {
      const response = await axiosInstance.get(`/users/currentRole`);
      const storedUser = localStorage.getItem("user");
      const userInfo = storedUser ? JSON.parse(storedUser) : {};
      const fallbackRole = Array.isArray(userInfo?.roles)
        ? userInfo.roles[0]
        : "";
      const apiRole = (response?.data || "").toString().trim();
      let resolvedRole =
        apiRole && apiRole !== "None" ? apiRole : fallbackRole;

      if (!resolvedRole) {
        return;
      }

      const normalizedRole = normalizeRoleForRouting(resolvedRole);

      localStorage.setItem("currentRole", normalizedRole);
      dispatch(setCurrentRole(normalizedRole));
      dispatch(setSelectedTab(0));
      dispatch(setSalesPersonSelectedTab(0));

      if (navigateOnResolve) {
        const targetRoute = getDefaultRouteForRole(normalizedRole);
        if (targetRoute) {
          console.log("Navigating based on role:", normalizedRole, targetRoute);
          navigate(targetRoute);
        }
      }
    } catch (error) {
      console.log("Error getting current role:", error);
    }
  };

  const sendEmailOtp = async (email) => {
    if (!email) return;
    setEmailOtpLoading(true);
    setEmailOtpError("");
    let responseStatus;
    try {
      const res = await fetch(
        "https://api-uat-dashboard.azurewebsites.net/api/v1/auth/send-otp",
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );
      responseStatus = res.status;
      const data = await res.json().catch(() => null);
      if (!res.ok || !data?.success) {
        throw new Error(data?.message || "Failed to send OTP.");
      }
      setEmailOtpRequestedEmail(email);
      setEmailOtpOpen(true);
      setEmailOtpCode("");
      dispatch(showToast({ type: "success", message: data?.message || "OTP sent successfully." }));
    } catch (err) {
      const message = getApiErrorMessage(err?.message || "Failed to send OTP.", responseStatus);
      setEmailOtpError(message);
      dispatch(showToast({ type: "error", message }));
    } finally {
      setEmailOtpLoading(false);
    }
  };

  const verifyEmailOtp = async () => {
    if (!emailOtpRequestedEmail) return;
    if (!emailOtpCode.trim()) {
      setEmailOtpError("Enter the 4-digit OTP.");
      return;
    }
    setEmailOtpLoading(true);
    setEmailOtpError("");
    let responseStatus;
    try {
      const res = await fetch(
        "https://api-uat-dashboard.azurewebsites.net/api/v1/auth/verify-otp",
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: emailOtpRequestedEmail,
            otp: emailOtpCode.trim(),
            application_name: "tax_navigator",
          }),
        }
      );
      responseStatus = res.status;
      const data = await res.json().catch(() => null);
      if (!res.ok || !data?.success) {
        throw new Error(data?.message || "OTP verification failed.");
      }
      const redirectUrl =
        data?.sign_in_link || data?.redirecturl || data?.redirectUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }
      dispatch(showToast({ type: "success", message: data?.message || "OTP verified successfully." }));
    } catch (err) {
      const message = getApiErrorMessage(err?.message || "OTP verification failed.", responseStatus);
      setEmailOtpError(message);
      dispatch(showToast({ type: "error", message }));
    } finally {
      setEmailOtpLoading(false);
    }
  };

  const handleEmailOtpChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    const next = emailOtpCode.split("");
    next[index] = digit;
    const merged = next.join("").slice(0, 4);
    setEmailOtpCode(merged);
    if (digit && emailOtpRefs.current[index + 1]) {
      emailOtpRefs.current[index + 1]?.focus();
    }
  };

  const handleEmailOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !emailOtpCode[index] && emailOtpRefs.current[index - 1]) {
      emailOtpRefs.current[index - 1]?.focus();
    }
  };

  const handleEmailOtpPaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4);
    if (!pasted) return;
    setEmailOtpCode(pasted);
    const nextIndex = Math.min(pasted.length, 3);
    emailOtpRefs.current[nextIndex]?.focus();
  };

  const isRedirectingToApp = authReady && !!authUser;

  const renderBlockingLoader = (message) => (
    <div className="loading-screen">
      <div className="loading-wrapper">
        <div className="spinner">
          <div className="outer-ring"></div>
          <div className="inner-ring"></div>
        </div>

        <p className="loading-text" suppressHydrationWarning>
          {message}
        </p>

        {emailLinkError ? (
          <p className="loading-error">{emailLinkError}</p>
        ) : null}

        <div className="loading-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    </div>
  );

  // Firebase hasn't reported back yet on the very first render — show the
  // loader instead of the form so a valid SSO cookie never flashes it first.
  if (!authReady) {
    return renderBlockingLoader("Loading...");
  }

  if (emailLinkInProgress) {
    return renderBlockingLoader("Completing email sign-in...");
  }

  // Outside the email-link flow, nothing else will sign the user in once the
  // SSO handoff has resolved, so fall through to the form rather than spin.
  if (hasAuthRedirectParams && !authUser && (isEmailLinkFlow || !ssoCookieChecked)) {
    return renderBlockingLoader("Attempting automatic sign-in...");
  }

  if (isRedirectingToApp) {
    return renderBlockingLoader("Loading...");
  }

  // Covers the gap between "Firebase confirms no local session" and the SSO
  // cookie exchange resolving — without this the plain login form flashes
  // for a moment before a successful handoff swaps it for the signed-in view.
  if (authReady && !authUser && !isEmailLinkFlow && !ssoCookieChecked) {
    return renderBlockingLoader("Signing you in...");
  }

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loginHint || "");

  return (
    <div className="login-wrapper">
      <div className="login-shell">
        <div className="form-pane">
          <div className="form-inner">
            <div className="brand-block">
              <img src={Logo} alt="Tax Raven" className="brand-logo" />
              <p className="brand-sub">Set up your credential to get started</p>
            </div>

            {emailLinkError ? (
              <div className="error-banner">{emailLinkError}</div>
            ) : null}
            {/* toast handles errors */}

            <div className="hint-input">
              <input
                id="email"
                type="email"
                inputMode="email"
                placeholder="Enter your email"
                value={loginHint}
                onChange={(e) => setLoginHint(e.target.value.trim())}
                aria-label="Work email for single sign-on"
                autoComplete="email"
              />
            </div>

            <button
              disabled={!isEmailValid || continueSubmitting}
              className={`cta ${
                isEmailValid && !continueSubmitting ? "cta-enabled" : "cta-disabled"
              }`}
              onClick={handleLogin}
            >
              {continueSubmitting ? (
                <span className="inline-flex items-center gap-2">
                  <span className="h-4 w-4 rounded-full border-2 border-black/40 border-t-black animate-spin" />
                  Continue
                </span>
              ) : (
                "Continue"
              )}
            </button>

            {emailOtpOpen && (
              <div
                className="email-otp-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="email-otp-title"
                onKeyDown={(e) => {
                  if (e.key === "Escape") {
                    setEmailOtpOpen(false);
                    setEmailOtpError("");
                  }
                }}
                tabIndex={-1}
              >
                <div className="email-otp-card">
                  <div className="email-otp-header">
                    <div>
                      <h3 id="email-otp-title">Verify your email</h3>
                      <p>
                        Enter the 4-digit OTP sent to{" "}
                        <span className="email-otp-email">{emailOtpRequestedEmail}</span>
                      </p>
                    </div>
                    <button
                      type="button"
                      className="email-otp-close"
                      onClick={() => {
                        setEmailOtpOpen(false);
                        setEmailOtpError("");
                      }}
                      aria-label="Close"
                    >
                      ×
                    </button>
                  </div>

                  <div className="email-otp-body">
                    <div className="email-otp-inputs">
                      {Array.from({ length: 4 }).map((_, idx) => (
                        <input
                          key={`otp-${idx}`}
                          ref={(el) => {
                            emailOtpRefs.current[idx] = el;
                          }}
                          type="text"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          maxLength={1}
                          value={emailOtpCode[idx] || ""}
                          onChange={(e) => handleEmailOtpChange(idx, e.target.value)}
                          onKeyDown={(e) => handleEmailOtpKeyDown(idx, e)}
                          onPaste={handleEmailOtpPaste}
                          className="email-otp-input"
                        />
                      ))}
                    </div>

                    {emailOtpError ? (
                      <p className="email-otp-error">{emailOtpError}</p>
                    ) : null}

                    <div className="email-otp-actions">
                      <button
                        type="button"
                        disabled={emailOtpLoading}
                        onClick={() => sendEmailOtp(emailOtpRequestedEmail)}
                        className="email-otp-secondary"
                      >
                        {emailOtpLoading ? "Sending..." : "Resend OTP"}
                      </button>
                      <button
                        type="button"
                        disabled={emailOtpLoading}
                        onClick={verifyEmailOtp}
                        className="email-otp-primary"
                      >
                        {emailOtpLoading ? "Verifying..." : "Verify OTP"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="divider">
              <span>or continue with</span>
            </div>

            <div className="social-row">
              <button
                className="social-btn"
                onClick={() => handleSocialLogin("google")}
                aria-label="Login with Google"
              >
                <svg className="gmark" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                <span>Login With Google</span>
              </button>
              <button
                className="social-btn"
                onClick={() => handleSocialLogin("microsoft")}
                aria-label="Login with Microsoft"
              >
                <svg className="msmark" viewBox="0 0 24 24" aria-hidden="true">
                  <rect x="2" y="2" width="9" height="9" fill="#F25022" />
                  <rect x="13" y="2" width="9" height="9" fill="#7FBA00" />
                  <rect x="2" y="13" width="9" height="9" fill="#00A4EF" />
                  <rect x="13" y="13" width="9" height="9" fill="#FFB900" />
                </svg>
                <span>Login with Microsoft</span>
              </button>
            </div>

            <p className="terms">
              By creating an account, you agree to our{" "}
              <a
                href="https://canaryai.com/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Use
              </a>{" "}
              and{" "}
              <a
                href="https://canaryai.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              .
            </p>

            <div className="phone-auth">
              <button
                type="button"
                className="phone-toggle"
                onClick={() => setPhoneAuthOpen((v) => !v)}
              >
                Continue with phone
              </button>
              {phoneAuthOpen && (
                    <div className="phone-panel">
                      <div id="recaptcha-container" />
                      <div className="phone-input-row" ref={countryDropdownRef}>
                        <button
                          type="button"
                          className="country-trigger"
                          onClick={() => {
                            setCountryDropdownOpen((v) => !v);
                            setCountrySearch("");
                          }}
                          aria-label="Select country code"
                        >
                          <img
                            src={`https://flagcdn.com/w20/${selectedCountry.code.toLowerCase()}.png`}
                            srcSet={`https://flagcdn.com/w40/${selectedCountry.code.toLowerCase()}.png 2x`}
                            width="20"
                            height="15"
                            alt={selectedCountry.name}
                            className="country-flag-img"
                          />
                          <span className="country-dial">{selectedCountry.dialCode}</span>
                          <svg
                            className={`chevron${countryDropdownOpen ? " open" : ""}`}
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            width="14"
                            height="14"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>

                        {countryDropdownOpen && (
                          <div className="country-dropdown">
                            <input
                              type="text"
                              className="country-search"
                              placeholder="Search country..."
                              value={countrySearch}
                              onChange={(e) => setCountrySearch(e.target.value)}
                              autoFocus
                            />
                            <ul className="country-list">
                              {filteredCountries.length ? (
                                filteredCountries.map((c) => (
                                  <li
                                    key={c.code}
                                    className={`country-item${
                                      c.code === selectedCountry.code ? " selected" : ""
                                    }`}
                                    onClick={() => {
                                      setSelectedCountry(c);
                                      setCountryDropdownOpen(false);
                                      setCountrySearch("");
                                    }}
                                  >
                                    <img
                                      src={`https://flagcdn.com/w20/${c.code.toLowerCase()}.png`}
                                      srcSet={`https://flagcdn.com/w40/${c.code.toLowerCase()}.png 2x`}
                                      width="20"
                                      height="15"
                                      alt={c.name}
                                      className="country-flag-img"
                                    />
                                    <span className="country-name">{c.name}</span>
                                    <span className="country-dial muted">{c.dialCode}</span>
                                  </li>
                                ))
                              ) : (
                                <li className="country-item muted">No results</li>
                              )}
                            </ul>
                          </div>
                        )}

                        <input
                          type="tel"
                          inputMode="numeric"
                          placeholder="9876543210"
                          value={localPhone}
                          onChange={(e) =>
                            setLocalPhone(
                              e.target.value.replace(/\D/g, "").slice(0, phoneRule.max)
                            )
                          }
                          maxLength={phoneRule.max}
                          className="phone-number-input"
                        />
                      </div>
                  {phoneAuthStep === "code-sent" && (
                    <input
                      type="text"
                      inputMode="numeric"
                      placeholder="Enter OTP"
                      value={otpCode}
                      onChange={(e) => setOtpCode(e.target.value)}
                      className="phone-input"
                    />
                  )}
                  {phoneAuthError ? (
                    <p className="phone-error">{phoneAuthError}</p>
                  ) : null}
                  {phoneAuthStep === "idle" ? (
                    <button
                      type="button"
                      disabled={phoneAuthLoading || !isPhoneValid}
                      onClick={handleSendOtp}
                      className="phone-cta"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
                    >
                      {phoneAuthLoading && <CircularProgress size={16} thickness={5} style={{ color: "#555" }} />}
                      {phoneAuthLoading ? "Sending OTP..." : "Send OTP"}
                    </button>
                  ) : (
                    <button
                      type="button"
                      disabled={phoneAuthLoading}
                      onClick={handleVerifyOtp}
                      className="phone-cta"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
                    >
                      {phoneAuthLoading && <CircularProgress size={16} thickness={5} style={{ color: "#555" }} />}
                      {phoneAuthLoading ? "Verifying..." : "Verify OTP"}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="art-pane">
          <img className="art-img desktop" src={loginLogo} alt="Login" />
          <img className="art-img mobile" src={loginLogo} alt="Login" />
        </div>
      </div>
    </div>
  );
};

export default Login;
